export default "__VITE_ASSET__D5iU387u__"